<section class="vc-admin-state-panel" [class]="'vc-admin-state-panel--' + mode">
  <i [class]="iconClass"></i>

  <div class="vc-admin-state-panel__content">
    @if (titleKey) {
      <h4>{{ titleKey | translate }}</h4>
    }

    @if (descriptionKey) {
      <p>{{ descriptionKey | translate }}</p>
    }
  </div>

  @if (showRetry) {
    <button
      pButton
      type="button"
      class="p-button-sm"
      (click)="retry.emit()"
      [label]="retryLabelKey | translate"
    ></button>
  }
</section>
